import {
  ArrowsAltOutlined,
  DownOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { Button, Card, Dropdown, Menu, Popover, Space, Spin } from "antd";
import { useEndTime, useStartTime } from "../DateContext/DateContext";
import useActiveTimeCard from "./useActiveTimeCard";
import { useState } from "react";
import { GroupBy } from "../../lib/discordTypes";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip as ReTooltip,
  XAxis,
  YAxis,
} from "recharts";
import dayjs from "dayjs";

// TODO - refactor the analytics, make a general function for tracking and put this interface there. Follow tutorial (https://ashokraju.medium.com/using-segment-io-analytics-js-with-single-page-react-typescript-app-a8c12b4816c4)
declare global {
  interface Window {
    analytics: any;
  }
}

/**
 * ActiveTimeCard props
 * expandActiveTime: wether the component is expanded or not
 * setExpandActiveTime: state function to expand the card in the parent
 */
interface Props {
  expandActiveTime: boolean;
  setExpandActiveTime: React.Dispatch<React.SetStateAction<boolean>>;
}

function ActiveTimeCard(props: Props) {
  const { expandActiveTime, setExpandActiveTime } = props;
  const [groupBy, setGroupBy] = useState<GroupBy>(GroupBy.Hourly);
  const { startTime } = useStartTime();
  const { endTime } = useEndTime();
  const { loading, data } = useActiveTimeCard(startTime, endTime, groupBy);

  function handleMenuClick(e: any) {
    if (e.key === "1") {
      return;
    }
    if (e.key === "2") {
      setGroupBy(GroupBy.Daily);
    }
    if (e.key === "3") {
      setGroupBy(GroupBy.Hourly);
    }
  }

  const trackClick = (description: string) => {
    window.analytics.track(description);
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="2" onClick={() => trackClick("When to post - weekly")}>
        {GroupBy.Daily}
      </Menu.Item>
      <Menu.Item key="3" onClick={() => trackClick("When to post - hourly")}>
        {GroupBy.Hourly}
      </Menu.Item>
    </Menu>
  );

  const popupContent = (text: string) => (
    <div>
      <p>{text}</p>
    </div>
  );

  return (
    <Card
      style={{ marginBottom: 40 }}
      title="When to post?"
      bordered={false}
      extra={
        <Space>
          <p style={{ marginTop: 10 }}>Group by</p>
          <Dropdown className="joyride-date" overlay={menu}>
            <Button>
              {groupBy} <DownOutlined />
            </Button>
          </Dropdown>
          <Button onClick={() => setExpandActiveTime(!expandActiveTime)}>
            <div className="-mt-1">
              <ArrowsAltOutlined />
            </div>
          </Button>
          <Popover
            content={popupContent(
              "Average number of messages sent in public channels, by day of week or hour of the day."
            )}
            className="ml-3"
          >
            <InfoCircleOutlined />
          </Popover>
        </Space>
      }
    >
      <Spin spinning={loading}>
        <div
          style={{
            width: "100%",
            height: expandActiveTime ? "500px" : "250px",
          }}
        >
          <ResponsiveContainer>
            <LineChart
              width={430}
              data={data}
              margin={{
                top: 5,
                right: 5,
                left: 0,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="time_period" />
              <YAxis dataKey="avg" domain={["auto", "auto"]} />
              <Legend />
              <ReTooltip />
              <Line
                type="monotone"
                name="number of avg. messages sent (messages visible to Dots bot)"
                dataKey="avg"
                stroke="#8884d8"
                activeDot={{ r: 8 }}
              />
            </LineChart>
          </ResponsiveContainer>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: 20,
            }}
          >
            {groupBy === GroupBy.Hourly ? (
              <div>Timezone : {dayjs.tz.guess()}</div>
            ) : (
              ""
            )}
          </div>
        </div>
      </Spin>
    </Card>
  );
}

export default ActiveTimeCard;
